export function scoreStefBlCandidate(candidate, row) {
  return (
    // Un BL contenant des barres obliques est un debut beaucoup plus fiable
    // qu'un petit fragment place juste au-dessus de la LDV.
    (candidate.token.includes('/') ? -100 : 0) +
    // Lorsque PDF.js fusionne "poids + BL", le BL est le dernier nombre du
    // bloc, par exemple "245 60794/20693/1".
    (candidate.tokenIndex === candidate.tokenCount - 1 ? 0 : 40) +
    // Le debut du BL est sur la premiere ligne de la position.
    Math.max(0, candidate.y - row.minY) +
    (row.x === null ? 0 : Math.abs(candidate.x - row.x) * 0.1) -
    Math.min(candidate.token.length, 30) * 0.05
  );
}

export function rankStefBlCandidates(candidates, row) {
  return candidates
    .map((candidate) => ({
      ...candidate,
      score: scoreStefBlCandidate(candidate, row),
    }))
    .sort((first, second) => first.score - second.score);
}
